import { Factory } from "@/data/dao/Factory";
import { RoomDao } from "@/data/dao/service/RoomDao";
import { ServiceAvailableFor } from "@/data/model/Enums";
import type { IRoomWithService } from "@/data/model/Room";
import { Format } from "@/data/util/Format";

import { BaseTabbedController } from "@/portal/controller/BaseTabbedController";
import { FloorPlanner } from "@/portal/elements/FloorPlanner";
import { ServiceEditor } from "@/portal/elements/ServiceEditor";
import { RoomForm } from "@/portal/forms/RoomForm";
import { RoomKioskForm } from "@/portal/forms/RoomKioskForm";
import { TastierGlobal } from "@/portal/globalAccess";

export class RoomController extends BaseTabbedController<IRoomWithService> {
    private roomForm: RoomForm;
    private floorPlanner?: FloorPlanner;
    private endUserServiceEditor?: ServiceEditor;
    private operatorServiceEditor?: ServiceEditor;
    private kioskForm?: RoomKioskForm;

    constructor(element: JQuery) {
        super(element, Factory.getInstance(RoomDao));

        this.roomForm = new RoomForm(this.formContentByTabName("roomedit"));
        this.roomForm.onSaved = (newModel) => {
            if (this.floorPlanner !== undefined) this.floorPlanner.onChangeShape(newModel.shape);
        };

        this.registerModelForm(this.roomForm);

        this.onActivateTab = (newTab) => {
            if (newTab === "roomplaner") this.showFloorPlanner();
            else if (newTab === "services") {
                this.showServiceEditor();
                this.showOperatorServiceEditor();
                this.showKioskForm();
            }
        };
    }

    protected onModelLoaded(m?: IRoomWithService) {
        if (m === undefined) {
            this.disableTabs(["roomplaner", "services"]);
            const vw = $("#kt_header > #kt_header_menu_wrapper");
            if (vw.find("> .selectedlocation").length === 0)
                vw.append(
                    '<div class="selectedlocation">' +
                        Format.htmlEscape(TastierGlobal.getLocationSwitch()!.getCurrentLocationName()) +
                        "</div>"
                );
        } else this.enableTabs(["roomplaner", "services"]);

        this.roomForm.setData(m);
    }

    private showFloorPlanner() {
        if (this.floorPlanner === undefined)
            this.floorPlanner = new FloorPlanner(this.model!).appendTo(
                this.formContentByTabName("roomplaner").find("> .kt-portlet__body")
            );
        else window.setTimeout(() => this.floorPlanner!.onResize(), 10);
    }

    private showServiceEditor() {
        if (this.endUserServiceEditor === undefined)
            this.endUserServiceEditor = new ServiceEditor(this.model!, ServiceAvailableFor.EndUsers).appendTo(
                this.formContentByTabName("services").find("> .kt-portlet__body #serviceeditorwrapper")
            );
    }

    private showOperatorServiceEditor() {
        if (this.operatorServiceEditor === undefined)
            this.operatorServiceEditor = new ServiceEditor(this.model!, ServiceAvailableFor.Operators).appendTo(
                this.formContentByTabName("services").find("> .kt-portlet__body #operatorserviceeditorwrapper")
            );
    }

    private showKioskForm() {
        if (this.kioskForm === undefined) {
            this.kioskForm = new RoomKioskForm(this.formContentByTabName("services"));
            this.kioskForm.onSaved = (m) => (this.model = m);
        }

        this.kioskForm.setData(this.model);
    }
}
